let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page000_game2/img/bcg.jpg',
    pos: {
      x: 584,
      y: 0,
    },
    width: 751,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page000_game2/audio/5_rabbit.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 129,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/9_red.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 258,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/1_hello.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 384,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/3_Tom.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 507,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/10_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 634,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 757,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/11_green.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 866,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/13_pink.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 126,
        x: 1203,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/4_Lisa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 249,
        x: 1206,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/14_orange.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 382,
        x: 1212,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/2_bye_bye.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 506,
        x: 1215,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/8_blue.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 638,
        x: 1220,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 751,
        x: 1225,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game2/audio/12_purple.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game2/img/audioOn.png', iconOff: 'games/page000_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 869,
        x: 1228,
      },
      unit: 'px',
    },
  ],
};

export default elements;
